export default {
  state: {
    css: [],
    dbCss: [],
    loadedCss: [],
    fontOptions: [],
    queryString: '',
    selectedPreviewForm: [],
    showSearchField: false,
    searchFormField: {}
  },

  mutations: {
    searchCsskey: (state, queryString) => {
      queryString = queryString.toLowerCase();
      for (let i = 0; i <= state.loadedCss.length - 1; i++) {
        for (let j = 0; j <= state.loadedCss[i].form.length - 1; j++) {
          var tempArr = [];
          tempArr.push(state.loadedCss[i].form[j]);
          state.searchFormField = tempArr.find(x => x.displayName ? x.displayName.toLowerCase() == queryString : '');
          if (state.searchFormField) {
            state.showSearchField = true;
            return
          }
        }
        if (state.loadedCss[i].innerAccordion) {
          for (let k = 0; k <= state.loadedCss[i].innerAccordion[0].form.length - 1; k++) {
            var tempArr = [];
            tempArr.push(state.loadedCss[i].innerAccordion[0].form[k]);
            state.searchFormField = tempArr.find(x => x.displayName ? x.displayName.toLowerCase() == queryString : '');
            if (state.searchFormField && state.searchFormField.hasOwnProperty('key')) {
              state.showSearchField = true;
              return
            }
          }
        }
      }
      state.showSearchField = false;
      state.searchFormField = {};
      console.log("There is no result found. Refine your search string");
    }
  },
  actions: {
    searchCsskey: (context, payload) => {
      context.commit('searchCsskey', payload)
    }
  }
}